import React, { Component } from "react"
import PropTypes from "prop-types"
import DatePicker from "react-datepicker"
import moment from "moment"

import "react-datepicker/dist/react-datepicker.css"

class RegisterDate extends Component {
  handleDateChange = (date) => {
    this.props.handleObjectChange({ date: date.toDate() })
  }

  render() {
    const date = moment(this.props.date)
    const today = moment() // 取得今天的日期

    return (
      <div className="field is-horizontal">
        <div className="field-label is-medium">
          <label className="label">購買日期</label>
        </div>
        <div className="field-body">
          <div className="field">
            <DatePicker
              className="input"
              dateFormat="YYYY/MM/DD"
              selected={date}
              onChange={this.handleDateChange}
              maxDate={today} // 設定最大可選日期為今天
              required
            />
            <p className="help is-danger">必填</p>
          </div>
        </div>
      </div>
    )
  }
}

RegisterDate.propTypes = {
  handleObjectChange: PropTypes.func.isRequired,
}

export default RegisterDate



// WEBPACK FOOTER //
// ./src/components/RegisterDate.js